export var createMuiTableBodyOverrides = function (_a) {
    var palette = _a.palette, shape = _a.shape;
    return ({
        root: {
            backgroundColor: palette.background.overlays,
            borderRadius: shape.borderRadius,
        },
    });
};
//# sourceMappingURL=MuiTableBody.js.map